<script lang="ts">
	import { analyticNames } from './stores'
	import type { Result } from '$lib/analytics/types/analyticalEvaluation'
	import AnalysisScale from '$lib/analytics/AnalysisScale.svelte'
	import AnalysisScaleBadge from '$lib/analytics/AnalysisScaleBadge.svelte'
	import Tooltip_v5 from '$lib/atoms/Tooltip_v5.svelte'
	import { t } from '$i18n/i18n'

	let { evaluation, compact }: { evaluation: Record<string, Result>; compact: boolean } = $props()
	let entries = $derived(Object.entries(evaluation))

	const singleEntry = $derived(entries.length === 1 ? entries[0] : undefined)
	const singleResult = $derived(singleEntry?.[1].value !== undefined ? singleEntry[1] : undefined)

	const visibleEntries = $derived(
		entries.filter(
			([, result]) =>
				result.description !== 'NOT_APPLICABLE' &&
				result.description !== '/' &&
				result.value !== undefined
		)
	)
</script>

{#if evaluation}
	{#if singleResult}
		{#if compact || singleResult.description === '/'}
			{singleResult.description}
		{:else}
			<AnalysisScale result={singleResult} />
		{/if}
	{:else if visibleEntries.length}
		{#each visibleEntries as [key, result], i (key)}
			<span class="evaluation-result-text">
				{$analyticNames[key]}:&nbsp;
				<Tooltip_v5>
					<AnalysisScaleBadge
						ordinal={result.priority}
						maxOrdinal={result.maxOrdinal}
						description={result.description}
					/>
					{#snippet content()}
						<div class="evaluation-result-tooltip">
							<span class="evaluation-result-tooltip-label">{$t('Analysis.scale.title')}</span>
							<AnalysisScale {result} />
						</div>
					{/snippet}
				</Tooltip_v5>
				{#if i < visibleEntries.length - 1}&nbsp;{/if}
			</span>
		{/each}
	{:else}
		/
	{/if}
{/if}

<style>
	.evaluation-result-text {
		color: #000;
		font-family: Roboto, sans-serif;
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 20px;
		white-space: nowrap;
		display: inline-flex;
		align-items: center;
		gap: 4px;
		padding-bottom: 6px;
		vertical-align: middle;
	}

	.evaluation-result-tooltip {
		display: flex;
		flex-direction: column;
		gap: 4px;
		width: 100%;
		overflow: hidden;

		.evaluation-result-tooltip-label {
			color: #000;
			font-family: Roboto, sans-serif;
			font-size: 12px;
			font-style: normal;
			font-weight: 500;
			line-height: 20px;
		}
	}
</style>
